// Import firebase services
import { firebaseAuth } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

export const LeasesRepository = {

	/*
	**  Register the mixins
	*/

	mixins: [

		BugsnagService

	],

	/*
	**  Set up the data
	*/

	data: () => ({
        new_lease: {
			id: null,
			type: null,
			meta: {
				created_at: moment().unix(),
				updated_at: moment().unix(),
				deleted_at: null,
				app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
				version: 1
			},
			attributes: {
				status: null, // Pending, Active, Expired
				details: {
					start_date: null,
					end_date: null,
					signature: false
				},
				resident: {
					first_name: null,
					last_name: null
				},
				unit: {
					set_availability: false,
					number: null
				},
				rent: {
					amount: 0,
					cycle: null,
					beginning_at: null,
					prorated: false,
					first_months_rent: 0,
					due_on: 1,
					post_days_in_advance: 0
				},
				security_deposit: {
					amount: 0,
					received_at: null,
					deposited_at: null,
					dispersed: {
						dispersed_at: null,
						amount: 0,
						notes: null
					}
				},
				renewal: {
					send_notice: false,
					notice_date: null
				}
			},
			metrics: {
				initial_balance: 0,
				outstanding_balance: 0,
				rent: {
					total_charges: 0
				},
				payments: {
					payments_made: 0,
					payments_remaining: 0
				}
			},
			links: {
				documents: []
			},
			relationships: {
				property: null,
				user: firebaseAuth.currentUser.uid,
				unit: null,
				resident: null,
				active_rent: null
			}
		}
    }),

    /*
	**  Set the methods
	*/

	methods: {

        resetNewLeaseProp: function() {

            try {

                /*
                **  Reset the prop
                **  @prop: @here
                */

                this.new_lease = {
                    id: null,
                    type: null,
                    meta: {
                        created_at: moment().unix(),
                        updated_at: moment().unix(),
                        deleted_at: null,
                        app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
                        version: 1
                    },
                    attributes: {
                        status: null, // Pending, Active, Expired
                        details: {
                            start_date: null,
                            end_date: null,
                            signature: false
                        },
                        resident: {
                            first_name: null,
                            last_name: null
                        },
                        unit: {
                            set_availability: false,
                            number: null
                        },
                        rent: {
                            amount: 0,
                            cycle: null,
                            beginning_at: null,
                            prorated: false,
                            first_months_rent: 0,
                            due_on: 1,
                            post_days_in_advance: 0
                        },
                        security_deposit: {
                            amount: 0,
                            received_at: null,
                            deposited_at: null,
                            dispersed: {
                                dispersed_at: null,
                                amount: 0,
                                notes: null
                            }
                        },
                        renewal: {
                            send_notice: false,
                            notice_date: null
                        }
                    },
                    metrics: {
                        initial_balance: 0,
                        outstanding_balance: 0,
                        rent: {
                            total_charges: 0
                        },
                        payments: {
                            payments_made: 0,
                            payments_remaining: 0
                        }
                    },
                    links: {
                        documents: []
                    },
                    relationships: {
                        property: null,
                        user: firebaseAuth.currentUser.uid,
                        unit: null,
                        resident: null,
                        active_rent: null
                    }
                }

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Reset the new lease prop.',
                    errorType: 'Application',
                    section: 'Add Lease',
                    uid: 'oxx6Ur6ZFh4k5dWCBALA',
                    error: e
                });

            }

        }

    }

}